import type { Npc, RoomDef } from '../defs.ts'
import { look } from '../town/kit.ts'

export const room: RoomDef = {
  id: 'arcade',
  name: 'Pixel Pit',
  blurb: 'Blinking cabinets and a dance floor that never sleeps.',
  w: 12, d: 10, outdoor: false, ground: 'neon', accent: '#b07bff',
  wall: { color: '#3a3366', trim: '#b07bff' },
  zones: [],
  spawn: [9, 3],
  props: [
    { kind: 'dancefloor', x: 4, y: 4, w: 4, d: 3 },
    { kind: 'arcade', x: 1, y: 0, color: '#ff5d8f' }, { kind: 'arcade', x: 2, y: 0, color: '#4fd1ff' }, { kind: 'arcade', x: 3, y: 0, color: '#ffd166' },
    { kind: 'arcade', x: 5, y: 0, color: '#7cf29c' }, { kind: 'arcade', x: 6, y: 0, color: '#b07bff' },
    { kind: 'djbooth', x: 8, y: 0 },
    { kind: 'vending', x: 0, y: 2, color: '#ff5d8f' }, { kind: 'vending', x: 0, y: 3, color: '#4fd1ff' },
    { kind: 'beanbag', x: 9, y: 5, color: '#ff8fab', face: -1 }, { kind: 'beanbag', x: 10, y: 6, color: '#7cf29c', face: -1 },
    { kind: 'beanbag', x: 9, y: 8, color: '#ffd166', face: -1 }, { kind: 'beanbag', x: 2, y: 8, color: '#4fd1ff', face: 1 },
    { kind: 'beanbag', x: 1, y: 6, color: '#b07bff', face: 1 },
    { kind: 'plant', x: 11, y: 9 }, { kind: 'plant', x: 0, y: 9 },
  ],
  walls: [
    { kind: 'neon', wall: 'left', at: 4.6, len: 3.4, text: 'PIXEL PIT', color: '#ff5dd8' },
    { kind: 'neon', wall: 'back', at: 1.0, len: 2.8, text: 'PLAY', color: '#4fd1ff' },
    { kind: 'door', wall: 'back', at: 10, len: 1 },
    { kind: 'painting', wall: 'left', at: 8.2, len: 1.2, color: '#7cf29c' },
  ],
  portals: [{ x: 10, y: 0, to: 'town', out: [10, 1], label: 'Outside' }],
  critters: [],
  places: [], spots: [], cap: 30, softCap: 22,
}

export const npcs: Npc[] = [
  {
    id: 'npc-dj', name: 'DJ Pixel', role: 'DJ', look: look('djpixel', 3, 19, 4, 'headphones'), speed: 1.5,
    stops: [
      { x: 8, y: 1, wait: 12, emote: 'smug', say: -1 },
      { x: 9, y: 1, wait: 12, emote: 'happy' },
      { x: 6, y: 5, wait: 6, say: -1 },
    ],
    lines: ['This next one’s a bop.', 'Hit the dance floor!', 'Request? Lo-fi blob beats, coming right up.', 'Feel the bass in your jelly.'],
  },
  {
    id: 'npc-gamer', name: 'Joy', role: 'High scorer', look: look('joyhigh', 6, 22, 2, 'cap'), speed: 1.8,
    stops: [
      { x: 2, y: 1, wait: 14, emote: 'surprised', say: -1 },
      { x: 5, y: 1, wait: 14, emote: 'happy' },
      { x: 10, y: 6, wait: 10, say: -1 },
    ],
    lines: ['New high score!!', 'One more round. Just one.', 'Bet you can’t beat my score.', 'The claw machine is rigged, I swear.'],
  },
]
